import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	recentlyViewedProjects: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.projects.recently-viewed-projects',
		defaultMessage: 'Recently Viewed Projects',
		description: 'Section title for recently viewed projects',
	},
});
